import React, { useEffect, useState } from 'react';
import { View, Text, Button, StyleSheet } from 'react-native';

// 🔁 Função para geocodificação reversa com OpenCage
const reverseGeocode = async (lat, lng) => {
  const apiKey = 'ca7efe50ca6c4269bda1712e66052424'; // ← Substitua pela sua chave
  const url = `https://api.opencagedata.com/geocode/v1/json?q=${lat}+${lng}&key=${apiKey}&language=pt&pretty=1`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    const components = data.results[0]?.components;
    console.log('Dados da geocodificação :', components);
    return {
      bairro: components?.neighbourhood || components?.suburb || 'Bairro não encontrado',
      cidade: components?.city || components?.town || components?.village || 'Cidade não encontrada',
      estado: components?.state || 'Estado não encontrado',
      endereco: components?.road || 'endereço não encontrado',
      pais: components?.country || 'País não encontrado',
      cep: components?.postcode || 'CEP não encontrado',
    };
  } catch (error) {
    console.error('Erro ao buscar localização:', error);
    return null;
  }
};

const LocationScreen = ({ route, navigation }) => {
  
  const [location, setLocation] = useState(null);
  const [detalhes, setDetalhes] = useState(null);
  const [error, setError] = useState(null);

  const getLocation = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const coords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setLocation(coords);
          setError(null);

          const detalhesLocal = await reverseGeocode(coords.lat, coords.lng);
          setDetalhes(detalhesLocal);
        },
        (err) => {
          setError(`Erro ao obter localização: ${err.message}`);
          setLocation(null);
          setDetalhes(null);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      setError('Geolocalização não é suportada neste navegador.');
    }
  };

  useEffect(() => {
    getLocation();
  }, []);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>📍 Localização Atual</Text>

      {error && <Text style={styles.error}>{error}</Text>}

      {location && (
        <View style={styles.box}>
          <Text style={styles.text}>Latitude: {location.lat}</Text>
          <Text style={styles.text}>Longitude: {location.lng}</Text>
        </View>
      )}

      {detalhes && (
        <View style={styles.box}>
          <Text style={styles.text}>Bairro: {detalhes.bairro}</Text>
          <Text style={styles.text}>Cidade: {detalhes.cidade}</Text>
          <Text style={styles.text}>Endereço: {detalhes.endereco}</Text>
          <Text style={styles.text}>Estado: {detalhes.estado}</Text>
          <Text style={styles.text}>País: {detalhes.pais}</Text>
          <Text style={styles.text}>CEP: {detalhes.cep}</Text>
        </View>
      )}

      <Button title="Atualizar Localização" color={"#730d83"} onPress={getLocation} />
      <Text
        style={styles.laterButtonText}
        allowFontScaling={false}
        onPress={() => navigation.goBack()}
      >
        Voltar pra home
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({  
  laterButtonText: {
    textAlign: 'center',
    marginTop: 20,
    color: '#730d83',
    fontSize: 12, // Ajuste no tamanho da fonte
    fontWeight: '600',
  },

  container: {
    flex: 1,
    padding: 24,
    justifyContent: 'center',
    backgroundColor: '#f9f9f9',
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 16,
  },
  box: {
    marginBottom: 16,
    padding: 12,
    backgroundColor: '#fff',
    borderRadius: 8,
    elevation: 2,
  },
  text: {
    fontSize: 16,
    marginBottom: 4,
  },
  error: {
    color: 'red',
    marginBottom: 12,
  },
});

export default LocationScreen;
